import { api } from '../../lib/api';

const toQuery = (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
};

export const notificationsApi = {
  list: (params = {}) => api.get(`/notifications${toQuery(params)}`),
  unreadCount: () => api.get('/notifications/unread-count'),
  markRead: (id, read = true) => api.post(`/notifications/${id}/read`, { read }),
  markAllRead: () => api.post('/notifications/read-all'),
};
